<template>
  <DialogDef2 id="pretable" :show="true" :width="1249" :label="`${store}_排定桌號${date}`" @close="$emit('close')">
    <div id="pretable-body">
      <div id="pretable-body1">
        <RT :options="areas?.map(e => e.name)||[]" :defaultValue="area" @input="area=$event"></RT>
      </div>
      <div id="pretable-body2">
        <div id="body2-left">
          <div id="body2-left-1">
            <draggable :id="`sheet-${sheet._id}`" :group="{name: 'sheets', pull: 'clone', put: false}" tag="div" @dragstart="dragstart"
            v-for="(sheet) in sheets" :key="sheet._id" class="sheet" :style="{backgroundColor: sheet.color || 'var(--color-checked)', color: invertColor(sheet.color)}">
              <div>{{sheet.visitTime}}</div>
              <div><div :class="sheet.level===1?'vip':sheet.level===2?'vvip':sheet.level===3?'supervip':''"></div>{{sheet.orderer}}(
                <span v-if="sheet.reserveNum">{{sheet.reserveNum}}{{sheet.reserveNumChild?'大':'人'}}</span>
                <span v-if="sheet.reserveNumChild">{{sheet.reserveNumChild}}{{sheet.reserveNum?'小':'人'}}</span>
                )</div>
            </draggable>
          </div>
          <draggable tag="div" class="delete" :group="{name: 'delete', pull: false, put: true}"></draggable>
        </div>
        <div :style="{paddingTop: '50px'}">
          <div class="table title">
            <div class="hr1" v-for="(hr, h) in hours" :x="100+h*100" :l="hr" :style="{left: `${100+h*100}px` }" :key="hr"></div>
          </div>
          <div class="table tb" v-for="tb in tables" :key="tb.name" :style="{minWidth: `${100+hours.length*100}px`}">
            <div class="hr title" :style="{backgroundColor: '#E9E9E9'}">{{tb.name}}</div>
            <draggable :style="{width: '-webkit-fill-available'}" class="tableinner"  :id="tb.name"
              :group="{name: 'table', pull: true, put: true}"
              @remove="remove"
              @add="add">
              <div class="arrangedTable" v-for="(client, c) in tb.client" :key="`${tb.name}-${c}`" :id="`client-${client._id}`"
              :style="{
                  backgroundColor: client.color || 'var(--color-checked)',
                  color: invertColor(client.color),
                  left: `${moment(`${now} ${client.visitTime}`).diff(moment(`${now} 11:00`), 'minute') * 100 / 60}px`,
                  position: 'absolute'
                }">
                <div>{{client.visitTime}}</div>
                <div><div :class="client.level===1?'vip':client.level===2?'vvip':client.level===3?'supervip':''"></div>{{client.orderer}}(
                  <span v-if="client.reserveNum">{{client.reserveNum}}{{client.reserveNumChild?'大':'人'}}</span>
                  <span v-if="client.reserveNumChild">{{client.reserveNumChild}}{{client.reserveNum?'小':'人'}}</span>
                  )</div>
              </div>
            </draggable>
        </div>
        </div>
      </div>
    </div>
  </DialogDef2>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
import { getapi, postapi } from '../../store/fetch'
export default {
  components: {
    draggable
  },
  props: ['date', 'store', 'sheets'],
  computed: {
    ...mapState({
      restaurants: 'restaurants'
    }),
    hours () {
      return Array(24).fill(null).map((a, i) => i).slice(11, 21)
    }
  },
  data () {
    return {
      area: null,
      areas: [],
      item: null,
      tables: [],
      now: this.moment().format('yyyy-MM-DD')
    }
  },
  async mounted () {
    const areas = await getapi(`tables/store/${this.store}`)
    this.areas = areas
    this.area = areas[0]?.name
    this.tablesupdated()
  },
  watch: {
    area () {
      this.tablesupdated()
    }
  },
  methods: {
    getColor (id) {
      const x = this.sheets.find(e => e._id === id)
      return x.color || '#CACACA'
    },
    async tablesupdated () {
      this.$store.commit('setFetching', true)
      this.tables = []
      this.$nextTick(async () => {
        const tables = await getapi(`restaurant/table/${this.store}/${this.area}?` + new URLSearchParams({
          date: this.moment(this.date).startOf('day').toISOString()
        }))
        this.tables = tables
        this.$store.commit('setFetching', false)
      })
    },
    dragstart (ev) {
      console.log('dragstart', ev)
    },
    async remove (ev) {
      const to = ev.to.id
      if (!to) {
        const action = /sheet-/.test(ev.from.id) ? 'add' : 'move'
        const from = /sheet-/.test(ev.from.id) ? ev.from.id : ev.from.id
        const item = /client-/.test(ev.item.id) ? ev.item.id.replace('client-', '') : ev.from.id.replace('sheet-', '')
        console.log('remove', [action, from, to, item])
        await postapi(`restaurant/removetable/${item}`, { from })
        await this.tablesupdated()
        this.$emit('update')
      }
    },
    async add (ev) {
      const action = /sheet-/.test(ev.from.id) ? 'add' : 'move'
      const from = /sheet-/.test(ev.from.id) ? ev.from.id : ev.from.id
      const to = ev.to.id
      const item = /client-/.test(ev.item.id) ? ev.item.id.replace('client-', '') : ev.from.id.replace('sheet-', '')
      console.log('eveveev', action, from, to, item)
      switch (action) {
        case 'add':
          await postapi(`restaurant/addtable/${item}`, { to })
          break
        case 'move':
          await postapi(`restaurant/movetable/${item}`, { from, to })
          break
        default:
          break
      }
      setTimeout(async () => {
        await this.tablesupdated()
        this.$emit('update')
      }, 200)
    }
  }
}
</script>
<style lang="scss">
#pretable {
  .headerBox {
    background-color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
*, *::before, *::after {
  box-sizing: border-box;
}
#body2-left {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-rows: 1fr 100px;
  height: 100%;
  max-height: 758px;
}
#body2-left-1 {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 644px;
  overflow-y: auto;
}
.delete {
  margin-top: auto;
  z-index: 2;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #FF7373;
  border-radius: 3px;
  &::before {
    content: '';
    width: 50px;
    height: 50px;
    background-color: #FF7373;
    mask-image: url(/svg/btn/del.svg);
    mask-position: center;
    mask-repeat: no-repeat;
    border-top: 2px solid #CACACA;
    display: inline-block;
  }
  &::after {
    content: '刪除';
    font-size: 20px;
    color: #FF7373;
    display: inline;
  }
  &>div{
    display: none;
  }
}
.hr1 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #CACACA;
  height: 100%;
  margin-top: -9px;
  &::before {
    content: attr(l);
    position: absolute;
    top: -30px;
    background-color: #FFFFFF;
    transform: translateX(-50%);
  }
}
.tb {
  position: relative;
  .tableinner>:not(.arrangedTable) {
    display: none;
  }
  .tableinner {
    position: relative;
  }
}
.hr {
  width: 100px;
  min-width: 100px;
  border-left: 1px solid #CACACA;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.1em;
  .title {
    background-color: #CACACA;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #787878;
    &::before {
      content: '';
      display: inline;
    }
  }
}
.table {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #CACACA;
  z-index: 2;
  width: fit-content;
  &:nth-child(2) {
    border-top: 1px solid #CACACA;
  }
  &.title {
    z-index: 1;
    padding-left: 50px;
    height: 100%;
    position: absolute;
  }
}
.sheet {
  width: 100%;
  min-height: fit-content;
}
.sheet, .arrangedTable {
  display: flex;
  flex-direction: column;
  text-align: start;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  // color: #FFFFFF;
  // background-color: #FFFFFF;
  padding: 7.5px 20px;
  border-radius: 3px;
  gap: 5px;
  &>div{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
.arrangedTable {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
}
#pretable-body2 {
  display: grid;
  grid-template-columns: 220px 1fr;
  position: relative;
  &>:nth-child(1) {
    background-color: var(--color-infobox);
    width: 100%;
    flex-direction: column;
    padding: 11px;
    border-radius: 0 0 0 10px;
    overflow-y: auto;
    gap: 10px;
  }
  &>:nth-child(2) {
    overflow: auto;
  }
}
#pretable-body1 {
  height: 75px;
  background-color: var(--color-infobox);
  width: 100%;
  display: flex;
  align-items: center;
  padding-inline: 25px;
}
#pretable-body {
  height: 833px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 75px 758px;
  overflow: hidden;
}
.vip, .vvip, .supervip, .tags, .remarked {
  width: 23px;
  height: 23px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  background-color: #FFFFFF;
  border-radius: 15px;
  position: relative;
  z-index: 1;
  margin-right: 5px;
}
.vip {
  background-image: url(/vip.svg);
}
.vvip {
  background-image: url(/vvip.svg);
}
.supervip {
  background-image: url(/supervip.svg);
}
</style>
